// 人事小程序
// 隐私政策
const talentPolicy = r =>
    require.ensure(
        [],
        () => r(require("../views/talent/policy.vue")),
        "talentPolicy"
    );
const talentUserAgreement = r =>
    require.ensure(
        [],
        () => r(require("../views/talent/userAgreement.vue")),
        "talentUserAgreement"
    );
const talentSummary = r =>
    require.ensure(
        [],
        () => r(require("../views/talent/summary.vue")),
        "talentSummary"
    );
const talentPersonalInfo = r =>
    require.ensure(
        [],
        () => r(require("../views/talent/personalInfo.vue")),
        "talentPersonalInfo"
    );
const talentThirdPartyInfo = r =>
    require.ensure(
        [],
        () => r(require("../views/talent/thirdPartyInfo.vue")),
        "talentThirdPartyInfo"
    );
const talentLogoutFile = r =>
    require.ensure(
        [],
        () => r(require("../views/talent/logoutFile.vue")),
        "talentLogoutFile"
    );

const routes = [
    {
        path: "/talentPolicy",
        name: "talentPolicy",
        component: talentPolicy,
        meta: {
            title: "隐私政策"
        }
    },
    {
        path: "/talentUserAgreement",
        name: "talentUserAgreement",
        component: talentUserAgreement,
        meta: {
            title: "用户协议"
        }
    },
    {
        path: "/talentSummary",
        name: "talentSummary",
        component: talentSummary,
        meta: {
            title: "隐私政策摘要"
        }
    },
    {
        path: "/talentPersonalInfo",
        name: "talentPersonalInfo",
        component: talentPersonalInfo,
        meta: {
            title: "个人信息收集清单"
        }
    },
    {
        path: "/talentThirdPartyInfo",
        name: "talentThirdPartyInfo",
        component: talentThirdPartyInfo,
        meta: {
            title: "个人信息共享清单"
        }
    },
    {
        path: "/talentLogoutFile",
        name: "talentLogoutFile",
        component: talentLogoutFile,
        meta: {
            title: "个人信息共享清单"
        }
    },
    {
        path: "/talentWeb",
        name: "talentWeb",
        component: () => import(
            /* webpackChunkName: "talentWeb" */
            "@/views/talentWeb/index.vue"
        ),
        meta: { title: "人事小程序" }
    }
]

export default routes;


// WEBPACK FOOTER //
// ./src/router/talent.js